function getItemCart() {
  const cart = document.querySelector('.my-cart').dataset.cartItemCount;
  return Number(cart)
}

/* change image only mobile */
function changeImage(shadowRoot) {
  const imgElement = shadowRoot.querySelector('.image');
  if (window.innerWidth <= 959 && imgElement) {
    imgElement.src = 'https://cdn.shopify.com/s/files/1/0008/9260/0356/files/image-widget.png?v=1738951666';
  }
}

/* change styles */
function addStylesShadowRoot(shadowRoot) {
  const style = document.createElement('style');
  changeImage(shadowRoot);
  style.textContent = `

  .overlay {
    background: rgb(44 36 36 / 70%);
  }

  .root {
    z-index: 9999999999999999999999 !important;
    
  }

    .input-check label input[type='radio']:checked + span {
      background: none;
    }
    @media (min-width: 960px) {
      .container { padding-right: 20px; padding-left: 294px; }
      .root { width:690px; }
      .title { font-size: 14px; }
      .description { font-size: 32px; }
      .input-check span { font-size: 14px; }
      button { padding-top: 10px; padding-bottom: 10px; }
    }

    @media (max-width: 959px) {
      .body { margin-top: 148px; }
      .title { max-width: 100%; }
      .input-check span { font-size: 12px; }
    }
  `;
  shadowRoot.appendChild(style);
}

function setCookie(name, minutes) {
  const date = new Date();
  date.setTime(date.getTime() + (minutes * 60 * 1000));
  document.cookie = `${name}=true;expires=${date.toUTCString()};path=/`;
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  return parts.length === 2 ? parts.pop().split(';').shift() : null;
}

const observer = new MutationObserver((mutationsList) => {
  mutationsList.forEach(mutation => {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach(node => {
        if (node.nodeName.toLowerCase() === 'getsitecontrol-widget') {
          const shadowRoot = node.shadowRoot;
          shadowRoot ? addStylesShadowRoot(shadowRoot) : console.error('no found shadowRoot');
        }
      });
    }
  });
});

observer.observe(document.body, { childList: true, subtree: true });

/* show popup event api */
function runPopup() {
  if (!getCookie('modalShown')) {
    const numerDelay = document.querySelector('body').dataset.delayPopup;
    gsc('show', 451210);
    setCookie('modalShown', Number(numerDelay));
  }
  
}
document.addEventListener('mousemove', function(e) {
  if (e.clientY <= 0) {
    runPopup();
  }
});



function onChangeAjaxCart() {

  const btnsOpen = document.querySelectorAll('.open-popup');
  btnsOpen.forEach(btn => {

    if (getItemCart() >= 2) {
      btn.removeEventListener('click', runPopup);
      btn.addEventListener('click', runPopup);
    }
  });
}

document.addEventListener('liquid-ajax-cart:request-end', onChangeAjaxCart);